import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useForm,Controller } from "react-hook-form";
import { toast } from "react-toastify";
import { Button, Form, FormGroup, Label, Card, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Alert } from "reactstrap";
import CommonCardHeader from "../../coreComponents/CommonCardHeader";
import ApiService from "../../services/apiService";
import Breadcrumbs from "../../coreComponents/breadcrumbs";
import { ChevronDown } from "lucide-react";
import DateTimePicker from 'react-datepicker'



const Add = ({ title, parentTitle, fields, onSubmit,isAlert = false }:any) => {
  const navigate = useNavigate();
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [selectedValues, setSelectedValues] = useState<Record<string, any>>({});
  const { register, handleSubmit, formState: { errors },control} = useForm();

  const [visible, setVisible] = useState(true);
  const onDismiss = () => setVisible(false);

  const handleFormSubmit = async (data: any) => {
    try {
       // Create a shallow copy of the form data
       const formData = { ...data };
  
       // Iterate over each field
       fields.forEach((field: any) => {
         if (field.isDropdown && selectedValues[field.name]) {
           // Add the display value
           formData[field.name] = selectedValues[field.name][field.dropdownLabel];
           // Add the ID with the specified field name for ID
           if (field.idFieldName) {
             formData[field.idFieldName] = selectedValues[field.name].id;
           } else {
             formData[`${field.name}Id`] = selectedValues[field.name].id;
           }
         }
       });      
  
       await onSubmit(formData);
     } catch(error: any) {
      toast.error(error.message);
     }
  }

  const toggleDropdown = (fieldName: string) => {
    setActiveDropdown(activeDropdown === fieldName ? null : fieldName);
  };

  const handleSelectDropdownValue = (item: any, fieldName: string) => {
    setSelectedValues(prev => ({
      ...prev,
      [fieldName]: item
    }));
    setActiveDropdown(null);
  };

  

  return (
    <>
      <Breadcrumbs mainTitle={title} parent={parentTitle} />
      <div style ={{width : '100%', padding : '0px'}}>
      
        <Card className='p-3' >
          <CommonCardHeader title={title} headClass="pb-3" />
          {isAlert?<Alert color="warning"  isOpen={visible} toggle={onDismiss}>Please note that after a DUID is updated or added, it may take up to 5 minutes for the changes to be reflected on the control panel.</Alert>:null}
          <Form  onSubmit={handleSubmit(handleFormSubmit)}>
          {fields
  .reduce((rows: any[][], field: any, index: number) => {
    if (index % 2 === 0) rows.push([field]);
    else rows[rows.length - 1].push(field);
    return rows;
  }, [])
  .map((row: any[], rowIndex: number) => (
    <div className="row" key={rowIndex}>
      {row.map((field: any, colIndex: number) => (
        <div className="col-md-6 mb-3" key={`${field.name}-${colIndex}`}>
          <FormGroup>
            <Label className="col-form-label">{field.label}</Label>

            {field.isDropdown ? (
            <Dropdown
            isOpen={activeDropdown === field.name}
            toggle={() => toggleDropdown(field.name)}
            className="custom-dropdown-wrapper"
          >
            <DropdownToggle
              color="primary" // remove caret here
              className="custom-dropdown-toggle d-flex align-items-center justify-content-between"
              style={{
                backgroundColor: '#007bff',
                borderColor: '#007bff',
                color: '#fff',
                fontWeight: 500,
                borderRadius: '6px',
                padding: '8px 16px',
                width: '200px',
              }}
            >
              <span>
                {selectedValues[field.name]
                  ? selectedValues[field.name][field.dropdownLabel || 'name']
                  : `Select ${field.label}`}
              </span>
             
            </DropdownToggle>
          
            <DropdownMenu
              className="custom-dropdown-menu"
              style={{
                maxHeight: '200px',
                overflowY: 'auto',
                boxShadow: '0 0.5rem 1rem rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
                padding: '8px 0',
                
              }}
            >
              {field.dropdownData?.map((item: any) => (
                <DropdownItem
                  key={item.id}
                  onClick={() => handleSelectDropdownValue(item, field.name)}
                  className="custom-dropdown-item"
                  style={{
                    padding: '8px 16px',
                    fontSize: '14px',
                    cursor: 'pointer',
                  }}
                >
                  {item[field.dropdownLabel]}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
          
           
            ) :field.type === "dateTime" ? (
              <Controller
                name={field.name}
                control={control}
                rules={field.validation}
                render={({ field: { onChange, value } }) => (
                  <DateTimePicker
                    onChange={onChange}
                    value={value || new Date()}
                    dateFormat="dd/MM/yyyy HH:mm:ss"
                    placeholderText="DD-MM-YYYY"
                    showTimeSelect
                    className="form-control"
                    selected={value}
                    isClearable
                  />
                )}
              />
            ) : (
              <input
                className="form-control"
                type={field.type}
                placeholder={field.Placeholder || field.label}
                {...register(field.name, field.validation)}
              />
            )}

            {errors[field.name] && (
              <p className="text-danger mt-1">
                {errors[field.name]?.message?.toString()}
              </p>
            )}
          </FormGroup>
        </div>
      ))}
    </div>
))}


            <div className="form-group mb-0">
              <div className="d-flex justify-content-start mt-3">
                <Button color="primary" type="submit" className="me-1">
                   {title}
                </Button>
                <Button color="danger" onClick={() => navigate(-1)}>
                  Cancel
                </Button>
              </div>
            </div>
          </Form>
        </Card>
    
      </div>
    </>
  );
};

export default Add;
